module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/partners-05-e82970a1d08ed781de285e79f9393f72.png";